import React from 'react';

const Trope2: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-2 prefix__trope-decor"
      transform="translate(121.5, 236)"
    >
      <defs>
        <linearGradient
          id="bd4411fe-f6ee-41b5-ac86-801dd7049585"
          data-name="grad-21"
          x1="1319.36"
          y1="340.4"
          x2="1143.32"
          y2="340.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
      </defs>
      <g id="b5f1a21f-6716-43c4-9c0c-6edbb543ed8b" data-name="road">
        <path
          d="M695.22,59,676.36,73s-101-12-125,8-42,53-65,48-115,5-164,37-245,46-249,107,75,53,75,53l23,3c9,11,70,19,92,30l12,23c-30-18-142-34.52-198-37-74.8-3.31-104.35-86.69-48-117,35.81-26.28,165.65-46.19,182-56,20-12-17-19-17-19l27,1c12,9,54,5,113-27s132.51-20.91,142-21c22.61-.22,41.64-20.19,75-39C588,46.34,695.22,59,695.22,59Z"
          fill="#415c93"
        />
        <path
          d="M266.86,368.5s-94-25-141-32-98-40-82-80,136-65,205-81,108-52,157-56,81,1,96-8,30-27,44-35,41-18,82-14,59,2.52,59,2.52"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1031.86,138.5c57,4,112.5,5.5,169.5,48.5s27,80-3,85-176.82-13.93-202,29c-27.24,46.43,26.1,62.05,141,46,0,0,32,27,40,34,0,0-49,28-54,47,0,0-19-15-28-6s40-24,30-31-176.5-16.12-180-67c-2-29,41-62,126-67s125.61,9.66,133-17c18-65-212-85-212-85Z"
          fill="#415c93"
        />
        <path
          d="M1033.4,138.08l-39,16.56c-14-8.37-69.39-1.6-107.53-11.14-24-6-20.5-23.5-44.5-48.5s-73-17-73-17l13.39-21.4S805.36,55,850.36,73c20.84,8.33,26,20.31,28.66,30.38-.16-1.19-.25-2-.27-2.23.85,4.84,14.25,19.55,30.93,20.2,1,0,1.77.09,2.41.17h0C952.5,122.47,1033.4,138.08,1033.4,138.08Z"
          fill="#415c93"
        />
        <path
          d="M1010.1,146.49c-16.27-7.51-34.54-8-66.74-11.49-30.06-3.24-52.25,10.05-69.5-24.5C860.57,83.9,846.36,83,821.36,73s-45.67-7-45.67-7"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1177.36,381c42-12,83,2,140,3s71-23,72-40-62-63-142-34-110,37-110,37Z"
          fill="#415c93"
        />
        <path
          d="M1015.43,145.36S1134.36,151,1183.36,188s53,66,10,75-132.35-5-180.5,12.5C947,299.4,957.47,333,1004.36,352c24.87,10.07,96.5,21.5,147.5,14.5,0,0,85-60,159-53s72,53,27,55-129-14-157-2-61,49-61,49"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      <g id="bdac7d4a-58cf-49ea-bbb4-cf8c74ac585e" data-name="decor">
        <g>
          <line
            x1="243.07"
            y1="399.41"
            x2="257.12"
            y2="391.36"
            fill="none"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.64"
          />
          <path
            d="M254.13,388.43l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06,22.12,12.76a.71.71,0,0,0,.4.11.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,254.13,388.43Z"
            fill="#548e8c"
          />
          <path
            d="M256.56,391.59a.79.79,0,0,1-.4-.1L234,378.72a.82.82,0,0,1-.39-.69.79.79,0,0,1,.39-.69L245.1,371a.8.8,0,0,1,1.09.29l11.06,19.16a.79.79,0,0,1-.13,1A.8.8,0,0,1,256.56,391.59ZM236,378l18.34,10.59-9.17-15.89Z"
            fill="#72bdc1"
          />
          <path
            d="M257.25,390.4l-11.06-19.15a.7.7,0,0,0-.36-.32c-.3.75-.78,1.33-1.09,2.08l.47-.27,9.17,15.88h0a17.66,17.66,0,0,1,2.55,2.9.62.62,0,0,0,.21-.15A.79.79,0,0,0,257.25,390.4Z"
            fill="#9cd8d8"
          />
          <g>
            <path
              d="M252.34,368.38c-5.33-3.05-9.67-.54-9.65,5.57s4.39,13.61,9.7,16.67,9.64.56,9.64-5.56S257.67,371.43,252.34,368.38Z"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M252.34,377.34c-1.05-.6-1.89-.11-1.89,1.09a4.22,4.22,0,0,0,1.9,3.26c1,.6,1.88.11,1.88-1.09A4.15,4.15,0,0,0,252.34,377.34Z"
              fill="#6986a3"
            />
            <path
              d="M284.66,387c-5.33-3.05-9.67-.54-9.64,5.56s4.39,13.62,9.69,16.68,9.65.56,9.65-5.57S290,390,284.66,387Z"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M284.66,395.32c-1.34-.77-2.43-.14-2.42,1.4a5.4,5.4,0,0,0,2.43,4.2c1.34.77,2.43.14,2.43-1.4A5.38,5.38,0,0,0,284.66,395.32Z"
              fill="#6986a3"
            />
            <polyline
              points="244.82 368.35 252.34 379.46 260.86 382.78"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="259.07 391.62 252.39 380.59 260.86 387.54"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="252.84 368.67 252.34 379.46 248.36 368"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="258.08 375.53 252.34 379.46 255.73 371.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="260.42 379.01 252.34 379.46 252.84 390.36"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="251.83"
              y1="379.78"
              x2="249.54"
              y2="388.05"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="251.56"
              y1="379.01"
              x2="247.52"
              y2="385.06"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="250.82"
              y1="379.01"
              x2="244.82"
              y2="380.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="250.45"
              y1="378.37"
              x2="243.77"
              y2="377.1"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="251.32"
              y1="377.96"
              x2="243.24"
              y2="372.75"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="275.02"
              y1="392.55"
              x2="293.62"
              y2="404.09"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="277.98 386.41 284.66 398.32 276.17 388.87"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="283.68 386.99 284.32 397.71 281.32 386.41"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="289.76 392.06 284.66 398.32 287.1 389.24"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="291.35 395.08 284.66 398.32 293 399.16"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M293.62,407c-.34-.19-7.95-7.79-7.95-7.79"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="287.1 409.26 284.66 398.32 290.96 409.26"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="283.41 408.48 284.66 398.32 281.32 405.62 279 403.06 284.66 398.32 276.17 396.33"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="276.96"
              y1="400.05"
              x2="284.03"
              y2="398.58"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="262.35"
              y1="357.22"
              x2="252.34"
              y2="379.46"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M257.34,368.35s8.4,2.24,9.88,19.7l17.44,10.27S282.82,369.07,257.34,368.35Z"
              fill="none"
              stroke="#e2b55a"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="280.5 374.4 271 390.23 268.05 392.72 271 397.12"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="257.34 362.84 257.34 360.08 266.82 354.42 271.68 354.42"
              fill="none"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polygon
              points="275.75 370.7 282.22 377.1 284.28 374.4 275.75 370.7"
              fill="#ff9a76"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M275,392.55s-4.46.74-5.76-.93-.83-5.24,1.74-4.12S275,392.55,275,392.55Z"
              fill="#e2b55a"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M269.54,396.33c-.83.34-3.32,1.56-3.32,1.56l2.34,1.43,3.23-1.61Z"
              fill="#ff9a76"
            />
            <polygon
              points="266.22 397.89 266.22 398.58 268.54 399.95 268.56 399.32 266.22 397.89"
              fill="#f2bdad"
            />
            <polygon
              points="271.79 397.71 271.79 398.32 268.54 399.95 268.56 399.32 271.79 397.71"
              fill="#a56556"
            />
          </g>
          <g opacity="0.62">
            <path
              d="M248.25,410.32c-5-2.49-5.66-7-1.45-10s11.76-3.5,16.76-1,5.66,7,1.45,10S253.26,412.82,248.25,410.32Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M254.41,405.85c-1-.48-1.11-1.37-.29-2a3.54,3.54,0,0,1,3.28-.2c1,.48,1.11,1.36.28,2A3.46,3.46,0,0,1,254.41,405.85Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M278.71,425.37c-5-2.5-5.66-7-1.45-10s11.76-3.49,16.76-1,5.66,7,1.45,10S283.72,427.86,278.71,425.37Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M284.44,421.21c-1.26-.63-1.43-1.77-.37-2.53a4.55,4.55,0,0,1,4.22-.26c1.26.62,1.42,1.76.36,2.53A4.5,4.5,0,0,1,284.44,421.21Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="244.12 404.68 255.86 404.79 262.81 409.56"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="267.9 403.79 256.67 404.27 266.08 407.18"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="248.73 410.56 255.86 404.79 245.81 407.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="256.3 411.08 255.86 404.79 252.31 411.27"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="259.98 411.11 255.86 404.79 263.63 399.73"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="255.81"
              y1="404.26"
              x2="260.24"
              y2="398.4"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="255.13"
              y1="404.43"
              x2="257.08"
              y2="398.38"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="254.73"
              y1="403.88"
              x2="252.53"
              y2="398.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="254.08"
              y1="403.92"
              x2="249.55"
              y2="399.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="254.28"
              y1="404.78"
              x2="246.28"
              y2="401.3"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="277.26"
              y1="415.33"
              x2="295.36"
              y2="423.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="274.66 420.62 286.5 419.71 275.36 418.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="278.18 424.63 285.89 419.75 276.49 423.14"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="284.98 426.67 286.5 419.71 281.59 426.08"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="287.93 426.36 286.5 419.71 291.64 425.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M297.33,422.14c-.31-.16-9.7-2.09-9.7-2.09"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="295.35 416.08 286.5 419.71 297.46 418.99"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="292.8 413.7 286.5 419.71 289.69 413.55 286.66 413.08 286.5 419.71 280.49 414.31"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="283.48"
              y1="413.05"
              x2="286.33"
              y2="419.1"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="246.05"
              y1="423.43"
              x2="255.86"
              y2="404.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M251,414.1s6.13,5.21,18.94-2.39l16.59,8S265.4,432.92,251,414.1Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="267.78 428.51 273.47 413.46 273.57 410 278.2 410.02"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="247.18 416.86 245.28 418.24 246.58 428.2 249.23 431.85"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="262.65 426.79 270.58 428.47 269.85 431.36 262.65 426.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M277.26,415.33s-1.93-3.73-3.79-3.87-4.05,2-1.88,3.37S277.26,415.33,277.26,415.33Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M276.86,409.32c-.22-.79-.74-3.28-.74-3.28l2.26,1,.66,3.23Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="276.12 406.04 276.59 405.7 278.8 406.76 278.38 407.09 276.12 406.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="279.04 410.32 279.46 410.02 278.8 406.76 278.38 407.09 279.04 410.32"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
          </g>
          <path
            d="M251.24,391l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L253,393.85a.71.71,0,0,0,.4.11.73.73,0,0,0,.35-.09A18.08,18.08,0,0,0,251.24,391Z"
            fill="#72bdc1"
          />
          <path
            d="M251.24,390.92l-17.92-10.35a7.34,7.34,0,0,1-2.47.4l.07.06L253,393.8a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.66,17.66,0,0,0,251.24,390.92Z"
            fill="#548e8c"
          />
          <path
            d="M246.35,397.81a.79.79,0,0,1-.39-.11l-22.12-12.77a.78.78,0,0,1-.4-.69.79.79,0,0,1,.4-.69l11.06-6.38a.79.79,0,0,1,1.09.29l11,19.15a.8.8,0,0,1-.69,1.2Zm-20.52-13.57,18.35,10.59L235,379Z"
            fill="#72bdc1"
          />
          <path
            d="M241,397.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,241,397.18Z"
            fill="#72bdc1"
          />
          <path
            d="M243.92,394.65,226,384.3a7.4,7.4,0,0,1-2.48.4l.08.06,22.12,12.77a.79.79,0,0,0,.39.11.87.87,0,0,0,.36-.09A17.72,17.72,0,0,0,243.92,394.65Z"
            fill="#548e8c"
          />
          <path
            d="M232.92,380.39l8.7-5c.31-.75.79-1.33,1.1-2.08a.78.78,0,0,0-.74,0l-11.06,6.38a.82.82,0,0,0-.39.69.79.79,0,0,0,.32.64,7.6,7.6,0,0,0,2.47-.4Z"
            fill="#69afad"
          />
          <path
            d="M241,397.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,241,397.18Z"
            fill="#548e8c"
          />
          <path
            d="M243.93,399l-11.06-19.15a.82.82,0,0,0-.36-.33c-.3.76-.79,1.33-1.09,2.08l.47-.27,9.17,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91,1,1,0,0,0,.21-.15A.8.8,0,0,0,243.93,399Z"
            fill="#9cd8d8"
          />
          <path
            d="M247,396.62l-11-19.16a.85.85,0,0,0-.36-.32c-.3.75-.79,1.33-1.09,2.08L235,379l9.18,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91l.21-.15A.8.8,0,0,0,247,396.62Z"
            fill="#9cd8d8"
          />
          <path
            d="M222.71,386.61l8.71-5c.3-.75.79-1.32,1.09-2.08a.82.82,0,0,0-.73,0l-11.06,6.39a.79.79,0,0,0-.08,1.32,7.66,7.66,0,0,0,2.48-.4Z"
            fill="#69afad"
          />
          <path
            d="M254.13,392.76l-11.06-19.15c-.71-.61-.71-.61-1.71.39-.31.75.57.62.26,1.37l.47-.27L251.26,391h0a18.08,18.08,0,0,1,2.55,2.9.6.6,0,0,0,.21-.14A.8.8,0,0,0,254.13,392.76Z"
            fill="#9cd8d8"
          />
        </g>
        <g>
          <image
            width="97"
            height="96"
            transform="translate(126.36 301)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon
            points="174.8 350.55 174.8 359.48 164.25 344.45 174.8 338.36 174.8 345.88 185.36 351.87 185.36 356.64 174.8 350.55"
            fill="none"
            stroke="#f416ca"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="178.13"
            y1="353.18"
            x2="178.13"
            y2="374.5"
            fill="none"
            stroke="#f416ca"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="178.13"
            y1="353.18"
            x2="178.13"
            y2="374.5"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="174.8 350.55 174.8 359.48 164.25 344.45 174.8 338.36 174.8 345.88 185.36 351.87 185.36 356.64 174.8 350.55"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <polygon
            points="587.84 43.77 587.84 47.5 582.32 40.58 587.84 37.39 587.84 41.32 594.86 40.5 593.86 44.5 587.84 43.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <polygon
            points="587.84 43.77 587.84 47.5 582.32 40.58 587.84 37.39 587.84 41.32 594.86 40.5 593.86 44.5 587.84 43.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <image
            width="87"
            height="85"
            transform="translate(545.36)"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABVCAYAAAA8AHhnAAAACXBIWXMAAAsSAAALEgHS3X78AAAGNElEQVR4Xu3a32obSRbH8d85VdV/FCubLNaGGXwRQtiL3M4L+CX8PMbP45fIC8xtroIxi/DgKLvJWJbV3VXnnL2w5DiaYQMDldbM1hdEY7ktw8dHpVbJZGYo5Ym/dULpj1dwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM1ZwM+a/dcJYEREBAB7/nyAB9if6z8G9wiUiesA0AGegr04wGIHo0Zd7DU37MgiP0AgATjbHxdv74+z4ywyf46s/wd4ij477GPUBFKB/AvQJO5ML4AKwKWAzwPYdeVTcXdgFQDOAbwE6mB9x55R6FgKA+oWzBmwLzK0F7F/vYLM30AfkMwCnsH1al0fD3YW9APgfAB/giH9F5AbC9SfhSPYwvf0z1vCRrROny3itz46gHwDdmeS9meKxL8UeYKeXcB4/uh6dn6APbllXCHVFvq50qGrydYXbqnZ1XU3qPjyb/D3I9QtfzeHb93AXAB+/BQMgnIEev/CN1SiTSyDCGejk9MvEevzo0n86r37iJxw9sTh0tZPWSAmENRAa0rTqFS2L05BMVqLJix1Wsry80sUd9GGpOIPhFDbmBI+HC9DxW/DsGAwcuR6d72+aUHdD0GnlKxKvvfhEFQcyihUZ972JsXLtEumQnLrkD0LCp5X8+rxKA1qZ4VIXgM7OYefvxgUe9zr3GLgFSBB58jk59smpq7ynFIbBh+DgA6KTaMwJcIGVQMqR0qAuUeUiVj13vk2Tz3c0RKXF7GWavbvEYgbFKUZB3TbamnsC0BKgNV5S81F4zQdMa3HE6nTw3nEKMXGV2FWoXWWOaxFuVLiRFJvKcW0x1qvo6+CGIG7iZz656nrtbt+AllPQyflvL+W+Z6PhbuvniSIrTcioeWLkWmWQOpA5T+o5SSChiogrYqpAUpnj2hLXxK7ynELsqyBd9DfuiWuc8MH8iF+1IJwAY764jbss7JTuWrIwEBik8EwkzOQcYM7I2AAwWBGJxQssOSPHilbEa8NOhKeHSje/KDVvNu/uRlwa9gI3KBsA+MnalL1J3HzDAyYgI2PaPMtIjCiQwYwNxkTK1BuzKLtKafhkhB82P3/8O7/sOzbasnAOGH4G6jS3GyMb1Gm3IhOwCkgdklIkIyQjkCH978cbWrLb3Tvf/s6J37HRcAFg+hOsTbDpLGivS7XWSbojNY0Co69vuL+ZbY8sCHx/rFl4RdaY01sja3D/THi82TNGo+LOAPvwGrrElU7EqaoXqodE5lI0l5yXqOYim0ZjHdQ4wukgqtF5ic4ksqZkdyzQXgZ1eiBOF5jbxc6mzhiNgru5qLfzzQ5X+x5mh5WIrMRpSL6KsQoywPygKgM515N3Pan1pL4n1T6p701ksMoPsY7RtSGp3EqXgrbv7x93u2v2//kmAvfTe/EaOr28ourli+Q+31FPDTny5CWBXLCk6jgqEwAJrGYqpEhchZg0xlqr1E3XUa6D4Icr+QDoqxEndtsokwt8Pb2vAF3cQf82D6rJC8s6DTcxakoDifZOtNOJrdXZOop2LoVuCNKtRXp50gxdXEePJrkX12kDq9sdsrGmFhhpb+FxD/sMAM+w2Wf42Hk+TE6WE0+cXL9WrgHyE1i3IrPWiaoXkZU8T14wq+UWc92FBcZbEoARJ3cnmwG2APT2/VzrwyZ9XoSUpt3AT4YeVdPXVdOtUtNT1fYx9kM9dLF93sbFapGAuawB2SdYYA9wtwDnG+D1awgwF8wWyf/SpDvU8enTfuiHLj7t+yF2/dB2bbw5/BgbXKXlvyEA5HhnKRgbFtiDZWHbdnnYftyzBOgVQLcArS9fPuwNtOnSDgbYxRo2XcJmx/v3CcS2vcEFfvvRzwL3u1rLn7/sbk1/up9wnAPnJ/uJum2vcIFHwGcgnN7ft9063GBu21vUbXuHu+1b24T7jLptb3H/Co1+tfBXruBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBmrOBm7L8nMX/Qu5BUxgAAAABJRU5ErkJggg=="
          />
          <line
            x1="589.86"
            y1="44.5"
            x2="589.58"
            y2="56.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="589.86"
            y1="44.5"
            x2="589.58"
            y2="56.29"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
        </g>
        <g>
          <g>
            <path
              d="M675.36,74s36-20,94,4l13.5-20.5S726.36,37,695.36,59Z"
              fill="#415c93"
            />
            <line
              x1="674.86"
              y1="51.5"
              x2="674.86"
              y2="73.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="723.86"
              y1="57.5"
              x2="723.86"
              y2="66.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="733.86"
              y1="39.5"
              x2="733.86"
              y2="48.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="771.86"
              y1="55.5"
              x2="771.86"
              y2="77.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="782.86"
              y1="35.5"
              x2="782.86"
              y2="57.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="694.86"
              y1="37.5"
              x2="694.86"
              y2="59.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M674.86,54.72s24,16.78,49-.22c0,0,15,15,48,5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M695.34,40.38s15.52,13.91,38.52,1c0,0,36,16.77,49-3.56"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M775.69,66S739.22,48.73,689,63.12"
            fill="none"
            stroke="#dcceea"
            strokeMiterlimit="10"
            strokeDasharray="12"
          />
        </g>
        <g>
          <polygon
            points="803.9 68.39 814.63 74.58 814.63 62.19 825.36 80.78 814.63 86.97 814.63 79.11 803.9 73.02 803.9 68.39"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <polygon
            points="803.9 68.39 814.63 74.58 814.63 62.19 825.36 80.78 814.63 86.97 814.63 79.11 803.9 73.02 803.9 68.39"
            fill="none"
            stroke="#f9eff8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.23"
          />
          <line
            x1="809.78"
            y1="76.36"
            x2="809.78"
            y2="100"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <image
            width="96"
            height="99"
            transform="translate(766.36 25)"
            xlinkHref="data:image/png;base64,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"
          />
        </g>
        <g>
          <polygon
            points="813.84 47.77 813.84 52.44 808.32 44.58 813.84 41.39 813.84 45.32 819.36 48.45 819.36 50.95 813.84 47.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <image
            width="85"
            height="85"
            transform="translate(771.36 4)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="815.58"
            y1="49.14"
            x2="815.58"
            y2="60.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="815.58"
            y1="49.67"
            x2="815.58"
            y2="60.14"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <polygon
            points="813.84 47.77 813.84 52.44 808.32 44.58 813.84 41.39 813.84 45.32 819.36 48.45 819.36 50.95 813.84 47.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.16"
          />
        </g>
        <g>
          <ellipse
            cx="1283.67"
            cy="343.5"
            rx="59.31"
            ry="16.5"
            fill="#324b77"
          />
          <ellipse
            cx="1283.67"
            cy="340.5"
            rx="59.31"
            ry="16.5"
            fill="url(#bd4411fe-f6ee-41b5-ac86-801dd7049585)"
          />
          <g opacity="0.71">
            <path
              d="M1258.86,343.5a8.38,8.38,0,0,0-.85.32c-.26.14-.51.33-.51.52,0,.39.61.78,1.08,1.07a22.42,22.42,0,0,0,3.27,1.46c1.13.43,2.28.79,3.44,1.12.58.15,1.17.3,1.76.4a5.49,5.49,0,0,0,1.81.11,7.25,7.25,0,0,1-3.7.09,21.15,21.15,0,0,1-3.59-1,14.54,14.54,0,0,1-3.33-1.7,4.41,4.41,0,0,1-.74-.64,1.21,1.21,0,0,1-.38-1c.14-.44.53-.54.81-.64A4.25,4.25,0,0,1,1258.86,343.5Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1293.86,348.5a66.44,66.44,0,0,1,7.33.29,36.77,36.77,0,0,0,7.26.12,12,12,0,0,0,3.41-.9,9.2,9.2,0,0,0,2.85-2,16.88,16.88,0,0,1,6.09-4.34c1.2-.41,2.37-.7,3.5-1.1l.86-.31a6.6,6.6,0,0,0,.78-.32,1,1,0,0,0,.61-1,3,3,0,0,0-.69-1.41,8.38,8.38,0,0,0-1.2-1.26,20.29,20.29,0,0,0-2.92-2.08,26.62,26.62,0,0,0-6.67-2.79,23,23,0,0,0-7.21-.87,24.26,24.26,0,0,1,14.26,3,16.91,16.91,0,0,1,3.1,2.1,8.69,8.69,0,0,1,1.34,1.37,3.74,3.74,0,0,1,.89,1.84,1.84,1.84,0,0,1-.21,1.18,2.22,2.22,0,0,1-.85.77,8.37,8.37,0,0,1-.9.4l-.87.32c-1.17.42-2.37.74-3.48,1.14a15.94,15.94,0,0,0-5.79,4.05,10.16,10.16,0,0,1-3.15,2.14,11.44,11.44,0,0,1-3.67.87C1303.51,350,1298.75,348.68,1293.86,348.5Z"
              fill="#31586d"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1255.86,330.5c-2,.83-4,1.58-6,2.32s-4,1.4-6,2.12a11.62,11.62,0,0,0-2.8,1.33,4.79,4.79,0,0,0-1.91,2.23,3,3,0,0,0,.5,2.8,8.93,8.93,0,0,0,2.26,2.2,8.22,8.22,0,0,1-2.58-2,3.55,3.55,0,0,1-.77-3.22,5.08,5.08,0,0,1,2.08-2.64,12.81,12.81,0,0,1,3-1.48c2-.66,4.07-1.33,6.12-1.95S1253.77,331,1255.86,330.5Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1287.86,330.5c-1.28,0-2.54-.13-3.81-.2s-2.53-.21-3.79-.27c-2.5-.13-5.06-.22-7.26.79a5.43,5.43,0,0,0-.8.4,5.19,5.19,0,0,0-.77.48,11.58,11.58,0,0,1-1.68,1,18.35,18.35,0,0,1-3.67,1.27c-1.24.31-2.49.55-3.72.82a12.56,12.56,0,0,0-1.83.46,1.92,1.92,0,0,0-.78.43c-.23.2-.11.56.11.79a.63.63,0,0,1-.23-.88,2.19,2.19,0,0,1,.8-.59,13,13,0,0,1,1.8-.68c1.22-.37,2.45-.7,3.64-1.09a21.78,21.78,0,0,0,3.45-1.38,12.49,12.49,0,0,0,1.55-1,6.67,6.67,0,0,1,.84-.54,5.76,5.76,0,0,1,.89-.46c2.5-1.1,5.22-.94,7.73-.63S1285.36,330,1287.86,330.5Z"
              fill="#305891"
            />
          </g>
        </g>
      </g>
      <g id="b4a7f677-95c6-4511-9075-b62b92c09595" data-name="wahts_next_room">
        <g>
          <line
            x1="1230.07"
            y1="413.41"
            x2="1244.12"
            y2="405.36"
            fill="none"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.64"
          />
          <path
            d="M1241.13,402.43l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06,22.12,12.76a.71.71,0,0,0,.4.11.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,1241.13,402.43Z"
            fill="#548e8c"
          />
          <path
            d="M1243.56,405.59a.79.79,0,0,1-.4-.1L1221,392.72a.82.82,0,0,1-.39-.69.79.79,0,0,1,.39-.69L1232.1,385a.8.8,0,0,1,1.09.29l11.06,19.16a.79.79,0,0,1-.13,1A.8.8,0,0,1,1243.56,405.59ZM1223,392l18.34,10.59-9.17-15.89Z"
            fill="#72bdc1"
          />
          <path
            d="M1244.25,404.4l-11.06-19.15a.7.7,0,0,0-.36-.32c-.3.75-.78,1.33-1.09,2.08l.47-.27,9.17,15.88h0a17.66,17.66,0,0,1,2.55,2.9.62.62,0,0,0,.21-.15A.79.79,0,0,0,1244.25,404.4Z"
            fill="#9cd8d8"
          />
          <g>
            <path
              d="M1239.34,382.38c-5.33-3.05-9.67-.54-9.65,5.57s4.39,13.61,9.7,16.67,9.64.56,9.64-5.56S1244.67,385.43,1239.34,382.38Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1239.34,391.34c-1-.6-1.89-.11-1.89,1.09a4.22,4.22,0,0,0,1.9,3.26c1,.6,1.88.11,1.88-1.09A4.15,4.15,0,0,0,1239.34,391.34Z"
              fill="#6986a3"
            />
            <path
              d="M1271.66,401c-5.33-3.05-9.67-.54-9.64,5.56s4.39,13.62,9.69,16.68,9.65.56,9.65-5.57S1277,404,1271.66,401Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1271.66,409.32c-1.34-.77-2.43-.14-2.42,1.4a5.4,5.4,0,0,0,2.43,4.2c1.34.77,2.43.14,2.43-1.4A5.38,5.38,0,0,0,1271.66,409.32Z"
              fill="#6986a3"
            />
            <polyline
              points="1231.82 382.35 1239.34 393.46 1247.86 396.78"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1246.07 405.62 1239.39 394.59 1247.86 401.54"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1239.84 382.67 1239.34 393.46 1235.36 382"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1245.08 389.53 1239.34 393.46 1242.73 385.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1247.42 393.01 1239.34 393.46 1239.84 404.36"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1238.83"
              y1="393.78"
              x2="1236.54"
              y2="402.05"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1238.56"
              y1="393.01"
              x2="1234.52"
              y2="399.06"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1237.82"
              y1="393.01"
              x2="1231.82"
              y2="394.59"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1237.45"
              y1="392.37"
              x2="1230.77"
              y2="391.1"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1238.32"
              y1="391.96"
              x2="1230.24"
              y2="386.75"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1262.02"
              y1="406.55"
              x2="1280.62"
              y2="418.09"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1264.98 400.41 1271.66 412.32 1263.17 402.87"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1270.68 400.99 1271.32 411.71 1268.32 400.41"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1276.76 406.06 1271.66 412.32 1274.1 403.24"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1278.35 409.08 1271.66 412.32 1280 413.16"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M1280.62,421c-.34-.19-7.95-7.79-7.95-7.79"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1274.1 423.26 1271.66 412.32 1277.96 423.26"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1270.41 422.48 1271.66 412.32 1268.32 419.62 1266 417.06 1271.66 412.32 1263.17 410.33"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1263.96"
              y1="414.05"
              x2="1271.03"
              y2="412.58"
              fill="none"
              stroke="#6986a3"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1249.35"
              y1="371.22"
              x2="1239.34"
              y2="393.46"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1244.34,382.35s8.4,2.24,9.88,19.7l17.44,10.27S1269.82,383.07,1244.34,382.35Z"
              fill="none"
              stroke="#e2b55a"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1267.49 388.4 1258 404.23 1255.05 406.72 1258 411.12"
              fill="none"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1244.34 376.84 1244.34 374.08 1253.83 368.42 1258.67 368.42"
              fill="none"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polygon
              points="1262.75 384.7 1269.22 391.1 1271.28 388.4 1262.75 384.7"
              fill="#ff9a76"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1262,406.55s-4.46.74-5.76-.93-.83-5.24,1.74-4.12S1262,406.55,1262,406.55Z"
              fill="#e2b55a"
              stroke="#e2b55a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1256.54,410.33c-.83.34-3.32,1.56-3.32,1.56l2.34,1.43,3.23-1.61Z"
              fill="#ff9a76"
            />
            <polygon
              points="1253.22 411.89 1253.22 412.58 1255.54 413.95 1255.56 413.32 1253.22 411.89"
              fill="#f2bdad"
            />
            <polygon
              points="1258.79 411.71 1258.79 412.32 1255.54 413.95 1255.56 413.32 1258.79 411.71"
              fill="#a56556"
            />
          </g>
          <g opacity="0.34">
            <path
              d="M1235.25,424.32c-5-2.49-5.66-7-1.45-10s11.76-3.5,16.76-1,5.66,7,1.45,10S1240.26,426.82,1235.25,424.32Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1241.41,419.85c-1-.48-1.11-1.37-.29-2a3.54,3.54,0,0,1,3.28-.2c1,.48,1.11,1.36.28,2A3.46,3.46,0,0,1,1241.41,419.85Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1265.71,439.37c-5-2.5-5.66-7-1.45-10s11.76-3.49,16.76-1,5.66,7,1.45,10S1270.72,441.86,1265.71,439.37Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1271.44,435.21c-1.26-.63-1.43-1.77-.37-2.53a4.55,4.55,0,0,1,4.22-.26c1.26.62,1.42,1.76.36,2.53A4.5,4.5,0,0,1,1271.44,435.21Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1231.12 418.68 1242.86 418.79 1249.81 423.56"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1254.9 417.79 1243.67 418.27 1253.08 421.18"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1235.73 424.56 1242.86 418.79 1232.81 421.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1243.3 425.08 1242.86 418.79 1239.31 425.27"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1246.98 425.11 1242.86 418.79 1250.63 413.73"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1242.81"
              y1="418.26"
              x2="1247.24"
              y2="412.4"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1242.13"
              y1="418.43"
              x2="1244.08"
              y2="412.38"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1241.73"
              y1="417.88"
              x2="1239.53"
              y2="412.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1241.08"
              y1="417.92"
              x2="1236.55"
              y2="413.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1241.28"
              y1="418.78"
              x2="1233.28"
              y2="415.3"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1264.26"
              y1="429.33"
              x2="1282.36"
              y2="437.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1261.66 434.62 1273.5 433.71 1262.36 432.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1265.18 438.63 1272.89 433.75 1263.49 437.14"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1271.98 440.67 1273.5 433.71 1268.59 440.08"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1274.93 440.36 1273.5 433.71 1278.64 439.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1284.33,436.14c-.31-.16-9.7-2.09-9.7-2.09"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1282.35 430.08 1273.5 433.71 1284.46 432.99"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1279.8 427.7 1273.5 433.71 1276.69 427.55 1273.66 427.08 1273.5 433.71 1267.49 428.31"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1270.48"
              y1="427.05"
              x2="1273.33"
              y2="433.1"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1233.05"
              y1="437.43"
              x2="1242.86"
              y2="418.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1238,428.1s6.13,5.21,18.94-2.39l16.59,8S1252.4,446.92,1238,428.1Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1254.78 442.51 1260.47 427.46 1260.57 424 1265.2 424.02"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1234.18 430.86 1232.28 432.24 1233.58 442.2 1236.23 445.85"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1249.65 440.79 1257.58 442.47 1256.85 445.36 1249.65 440.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1264.26,429.33s-1.93-3.73-3.79-3.87-4,2-1.88,3.37S1264.26,429.33,1264.26,429.33Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1263.86,423.32c-.22-.79-.74-3.28-.74-3.28l2.26,1,.66,3.23Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1263.12 420.04 1263.59 419.7 1265.8 420.76 1265.38 421.09 1263.12 420.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1266.04 424.32 1266.46 424.02 1265.8 420.76 1265.38 421.09 1266.04 424.32"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
          </g>
          <path
            d="M1238.24,405l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L1240,407.85a.71.71,0,0,0,.4.11.73.73,0,0,0,.35-.09A18.08,18.08,0,0,0,1238.24,405Z"
            fill="#72bdc1"
          />
          <path
            d="M1238.24,404.92l-17.92-10.35a7.34,7.34,0,0,1-2.47.4l.07.06L1240,407.8a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.66,17.66,0,0,0,1238.24,404.92Z"
            fill="#548e8c"
          />
          <path
            d="M1233.35,411.81a.79.79,0,0,1-.39-.11l-22.12-12.77a.78.78,0,0,1-.4-.69.79.79,0,0,1,.4-.69l11.06-6.38a.79.79,0,0,1,1.09.29l11,19.15a.8.8,0,0,1-.69,1.2Zm-20.52-13.57,18.35,10.59L1222,393Z"
            fill="#72bdc1"
          />
          <path
            d="M1228,411.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1228,411.18Z"
            fill="#72bdc1"
          />
          <path
            d="M1230.92,408.65,1213,398.3a7.4,7.4,0,0,1-2.48.4l.08.06,22.12,12.77a.79.79,0,0,0,.39.11.87.87,0,0,0,.36-.09A17.72,17.72,0,0,0,1230.92,408.65Z"
            fill="#548e8c"
          />
          <path
            d="M1219.92,394.39l8.7-5c.31-.75.79-1.33,1.1-2.08a.78.78,0,0,0-.74,0l-11.06,6.38a.82.82,0,0,0-.39.69.79.79,0,0,0,.32.64,7.6,7.6,0,0,0,2.47-.4Z"
            fill="#69afad"
          />
          <path
            d="M1228,411.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1228,411.18Z"
            fill="#548e8c"
          />
          <path
            d="M1230.93,413l-11.06-19.15a.82.82,0,0,0-.36-.33c-.3.76-.79,1.33-1.09,2.08l.47-.27,9.17,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91,1,1,0,0,0,.21-.15A.8.8,0,0,0,1230.93,413Z"
            fill="#9cd8d8"
          />
          <path
            d="M1234,410.62l-11-19.16a.85.85,0,0,0-.36-.32c-.3.75-.79,1.33-1.09,2.08l.46-.27,9.18,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91l.21-.15A.8.8,0,0,0,1234,410.62Z"
            fill="#9cd8d8"
          />
          <path
            d="M1209.71,400.61l8.71-5c.3-.75.79-1.32,1.09-2.08a.82.82,0,0,0-.73,0l-11.06,6.39a.79.79,0,0,0-.08,1.32,7.66,7.66,0,0,0,2.48-.4Z"
            fill="#69afad"
          />
          <path
            d="M1241.13,406.76l-11.06-19.15c-.71-.61-.71-.61-1.71.39-.31.75.57.62.26,1.37l.47-.27,9.17,15.88h0a18.08,18.08,0,0,1,2.55,2.9.6.6,0,0,0,.21-.14A.8.8,0,0,0,1241.13,406.76Z"
            fill="#9cd8d8"
          />
        </g>
        <g>
          <line
            x1="1200.07"
            y1="431.41"
            x2="1214.12"
            y2="423.36"
            fill="none"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.64"
          />
          <path
            d="M1211.13,420.43l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06,22.12,12.76a.71.71,0,0,0,.4.11.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,1211.13,420.43Z"
            fill="#548e8c"
          />
          <path
            d="M1213.56,423.59a.79.79,0,0,1-.4-.1L1191,410.72a.82.82,0,0,1-.39-.69.79.79,0,0,1,.39-.69L1202.1,403a.8.8,0,0,1,1.09.29l11.06,19.16a.79.79,0,0,1-.13,1A.8.8,0,0,1,1213.56,423.59ZM1193,410l18.34,10.59-9.17-15.89Z"
            fill="#72bdc1"
          />
          <path
            d="M1214.25,422.4l-11.06-19.15a.7.7,0,0,0-.36-.32c-.3.75-.78,1.33-1.09,2.08l.47-.27,9.17,15.88h0a17.66,17.66,0,0,1,2.55,2.9.62.62,0,0,0,.21-.15A.79.79,0,0,0,1214.25,422.4Z"
            fill="#9cd8d8"
          />
          <g>
            <path
              d="M1209.34,400.38c-5.33-3.05-9.67-.54-9.65,5.57s4.39,13.61,9.7,16.67,9.64.56,9.64-5.56S1214.67,403.43,1209.34,400.38Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1209.34,409.34c-1-.6-1.89-.11-1.89,1.09a4.22,4.22,0,0,0,1.9,3.26c1,.6,1.88.11,1.88-1.09A4.15,4.15,0,0,0,1209.34,409.34Z"
              fill="#496277"
            />
            <path
              d="M1241.66,419c-5.33-3.05-9.67-.54-9.64,5.56s4.39,13.62,9.69,16.68,9.65.56,9.65-5.57S1247,422,1241.66,419Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1241.66,427.32c-1.34-.77-2.43-.14-2.42,1.4a5.4,5.4,0,0,0,2.43,4.2c1.34.77,2.43.14,2.43-1.4A5.38,5.38,0,0,0,1241.66,427.32Z"
              fill="#496277"
            />
            <polyline
              points="1201.82 400.35 1209.34 411.46 1217.86 414.78"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1216.07 423.62 1209.39 412.59 1217.86 419.54"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1209.84 400.67 1209.34 411.46 1205.36 400"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1215.08 407.53 1209.34 411.46 1212.73 403.59"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1217.42 411.01 1209.34 411.46 1209.84 422.36"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1208.83"
              y1="411.78"
              x2="1206.54"
              y2="420.05"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1208.56"
              y1="411.01"
              x2="1204.52"
              y2="417.06"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1207.82"
              y1="411.01"
              x2="1201.82"
              y2="412.59"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1207.45"
              y1="410.37"
              x2="1200.77"
              y2="409.1"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1208.32"
              y1="409.96"
              x2="1200.24"
              y2="404.75"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1232.02"
              y1="424.55"
              x2="1250.62"
              y2="436.09"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1234.98 418.41 1241.66 430.32 1233.17 420.87"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1240.68 418.99 1241.32 429.71 1238.32 418.41"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1246.76 424.06 1241.66 430.32 1244.1 421.24"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1248.35 427.08 1241.66 430.32 1250 431.16"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M1250.62,439c-.34-.19-7.95-7.79-7.95-7.79"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1244.1 441.26 1241.66 430.32 1247.96 441.26"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1240.41 440.48 1241.66 430.32 1238.32 437.62 1236 435.06 1241.66 430.32 1233.17 428.33"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1233.96"
              y1="432.05"
              x2="1241.03"
              y2="430.58"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1219.35"
              y1="389.22"
              x2="1209.34"
              y2="411.46"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1214.34,400.35s8.4,2.24,9.88,19.7l17.44,10.27S1239.82,401.07,1214.34,400.35Z"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1237.49 406.4 1228 422.23 1225.05 424.72 1228 429.12"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1214.34 394.84 1214.34 392.08 1223.83 386.42 1228.67 386.42"
              fill="none"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polygon
              points="1232.75 402.7 1239.22 409.1 1241.28 406.4 1232.75 402.7"
              fill="#ff9a76"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1232,424.55s-4.46.74-5.76-.93-.83-5.24,1.74-4.12S1232,424.55,1232,424.55Z"
              fill="#9e2a4d"
            />
            <path
              d="M1226.54,428.33c-.83.34-3.32,1.56-3.32,1.56l2.34,1.43,3.23-1.61Z"
              fill="#ff9a76"
            />
            <polygon
              points="1223.22 429.89 1223.22 430.58 1225.54 431.95 1225.56 431.32 1223.22 429.89"
              fill="#f2bdad"
            />
            <polygon
              points="1228.79 429.71 1228.79 430.32 1225.54 431.95 1225.56 431.32 1228.79 429.71"
              fill="#a56556"
            />
          </g>
          <g opacity="0.31">
            <path
              d="M1205.25,442.32c-5-2.49-5.66-7-1.45-10s11.76-3.5,16.76-1,5.66,7,1.45,10S1210.26,444.82,1205.25,442.32Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1211.41,437.85c-1-.48-1.11-1.37-.29-2a3.54,3.54,0,0,1,3.28-.2c1,.48,1.11,1.36.28,2A3.46,3.46,0,0,1,1211.41,437.85Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1235.71,457.37c-5-2.5-5.66-7-1.45-10s11.76-3.49,16.76-1,5.66,7,1.45,10S1240.72,459.86,1235.71,457.37Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1241.44,453.21c-1.26-.63-1.43-1.77-.37-2.53a4.55,4.55,0,0,1,4.22-.26c1.26.62,1.42,1.76.36,2.53A4.5,4.5,0,0,1,1241.44,453.21Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1201.12 436.68 1212.86 436.79 1219.81 441.56"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1224.9 435.79 1213.67 436.27 1223.08 439.18"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1205.73 442.56 1212.86 436.79 1202.81 439.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1213.3 443.08 1212.86 436.79 1209.31 443.27"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1216.98 443.11 1212.86 436.79 1220.63 431.73"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1212.81"
              y1="436.26"
              x2="1217.24"
              y2="430.4"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1212.13"
              y1="436.43"
              x2="1214.08"
              y2="430.38"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1211.73"
              y1="435.88"
              x2="1209.53"
              y2="430.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1211.08"
              y1="435.92"
              x2="1206.55"
              y2="431.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1211.28"
              y1="436.78"
              x2="1203.28"
              y2="433.3"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1234.26"
              y1="447.33"
              x2="1252.36"
              y2="455.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1231.66 452.62 1243.5 451.71 1232.36 450.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1235.18 456.63 1242.89 451.75 1233.49 455.14"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1241.98 458.67 1243.5 451.71 1238.59 458.08"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1244.93 458.36 1243.5 451.71 1248.64 457.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1254.33,454.14c-.31-.16-9.7-2.09-9.7-2.09"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1252.35 448.08 1243.5 451.71 1254.46 450.99"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1249.8 445.7 1243.5 451.71 1246.69 445.55 1243.66 445.08 1243.5 451.71 1237.49 446.31"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1240.48"
              y1="445.05"
              x2="1243.33"
              y2="451.1"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1203.05"
              y1="455.43"
              x2="1212.86"
              y2="436.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1208,446.1s6.13,5.21,18.94-2.39l16.59,8S1222.4,464.92,1208,446.1Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1224.78 460.51 1230.47 445.46 1230.57 442 1235.2 442.02"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1204.18 448.86 1202.28 450.24 1203.58 460.2 1206.23 463.85"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1219.65 458.79 1227.58 460.47 1226.85 463.36 1219.65 458.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1234.26,447.33s-1.93-3.73-3.79-3.87-4,2-1.88,3.37S1234.26,447.33,1234.26,447.33Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1233.86,441.32c-.22-.79-.74-3.28-.74-3.28l2.26,1,.66,3.23Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1233.12 438.04 1233.59 437.7 1235.8 438.76 1235.38 439.09 1233.12 438.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1236.04 442.32 1236.46 442.02 1235.8 438.76 1235.38 439.09 1236.04 442.32"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
          </g>
          <path
            d="M1208.24,423l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L1210,425.85a.71.71,0,0,0,.4.11.73.73,0,0,0,.35-.09A18.08,18.08,0,0,0,1208.24,423Z"
            fill="#72bdc1"
          />
          <path
            d="M1208.24,422.92l-17.92-10.35a7.34,7.34,0,0,1-2.47.4l.07.06L1210,425.8a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.66,17.66,0,0,0,1208.24,422.92Z"
            fill="#548e8c"
          />
          <path
            d="M1203.35,429.81a.79.79,0,0,1-.39-.11l-22.12-12.77a.78.78,0,0,1-.4-.69.79.79,0,0,1,.4-.69l11.06-6.38a.79.79,0,0,1,1.09.29l11,19.15a.8.8,0,0,1-.69,1.2Zm-20.52-13.57,18.35,10.59L1192,411Z"
            fill="#72bdc1"
          />
          <path
            d="M1198,429.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1198,429.18Z"
            fill="#72bdc1"
          />
          <path
            d="M1200.92,426.65,1183,416.3a7.4,7.4,0,0,1-2.48.4l.08.06,22.12,12.77a.79.79,0,0,0,.39.11.87.87,0,0,0,.36-.09A17.72,17.72,0,0,0,1200.92,426.65Z"
            fill="#548e8c"
          />
          <path
            d="M1189.92,412.39l8.7-5c.31-.75.79-1.33,1.1-2.08a.78.78,0,0,0-.74,0l-11.06,6.38a.82.82,0,0,0-.39.69.79.79,0,0,0,.32.64,7.6,7.6,0,0,0,2.47-.4Z"
            fill="#69afad"
          />
          <path
            d="M1198,429.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1198,429.18Z"
            fill="#548e8c"
          />
          <path
            d="M1200.93,431l-11.06-19.15a.82.82,0,0,0-.36-.33c-.3.76-.79,1.33-1.09,2.08l.47-.27,9.17,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91,1,1,0,0,0,.21-.15A.8.8,0,0,0,1200.93,431Z"
            fill="#9cd8d8"
          />
          <path
            d="M1204,428.62l-11-19.16a.85.85,0,0,0-.36-.32c-.3.75-.79,1.33-1.09,2.08l.46-.27,9.18,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91l.21-.15A.8.8,0,0,0,1204,428.62Z"
            fill="#9cd8d8"
          />
          <path
            d="M1179.71,418.61l8.71-5c.3-.75.79-1.32,1.09-2.08a.82.82,0,0,0-.73,0l-11.06,6.39a.79.79,0,0,0-.08,1.32,7.66,7.66,0,0,0,2.48-.4Z"
            fill="#69afad"
          />
          <path
            d="M1211.13,424.76l-11.06-19.15c-.71-.61-.71-.61-1.71.39-.31.75.57.62.26,1.37l.47-.27,9.17,15.88h0a18.08,18.08,0,0,1,2.55,2.9.6.6,0,0,0,.21-.14A.8.8,0,0,0,1211.13,424.76Z"
            fill="#9cd8d8"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope2;
